<template>
  <v-container grid-list-md fluid>
    <v-layout column>
      <v-flex>
        <v-toolbar color="#eee" class="elevation-0 secondary--text mb-4" style="background: transparent">
          <v-toolbar-title>ITENS A VENDA</v-toolbar-title>
          <v-spacer></v-spacer>
           <v-tooltip bottom v-if="empresa">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon color="secondary" @click="dialogCadItem = true, dialogPin=true">
                <v-icon>add</v-icon>
              </v-btn>
            </template>
            <span>Cadastrar novo Item</span>
           </v-tooltip>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-tabs
      v-if="ready"
      fixed-tabs
      slider-color="secondary"
      v-model="tabs"
    >
      <v-tab v-if="posto">
        COMBUSTÍVEIS
      </v-tab>
      <v-tab>
        CONVENIÊNCIA
      </v-tab>
      <v-tab>
        DEMAIS ITENS
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tabs" class="mt-4">
      <v-tab-item v-if="posto">
        <v-layout row wrap class="card-row" justify-start>
          <v-flex
            xs12
            sm12
            md6
            lg6
            xl4
            v-for="(objeto, index) in itens_combustiveis"
            :key="index"
            class="mb-4"
          >
            <item
              :item="objeto"
              @editarItem="editarItem"
              @visualizarItem="visualizarItem"
              @deletarItem="abrirDialogConfirmacao, dialogPin=true"
              @editarDisponibilidade="editarDisponibilidade, dialogPin=true"
              @carregar="carregar"
            />
          </v-flex>
        </v-layout>
      </v-tab-item>
      <v-tab-item>
        <v-layout row class="card-row">
          <v-flex
            align-self-center
            style="
              justify-content: start;
              align-items: center;
              display: flex;
            "
          >
            <v-tooltip bottom>
              <v-btn
                icon
                @click="pagination_conveniencia.page--"
                slot="activator"
                :disabled="pagination_conveniencia.page == 1"
              >
                <v-icon size="40">arrow_back_ios</v-icon>
              </v-btn>
              <span>Ir para esquerda</span>
            </v-tooltip>
          </v-flex>
          <v-layout
            column
            v-for="(objeto, index) in itens_conveniencia"
            :key="index"
          >
            <item
              :item="objeto"
              @editarItem="editarItem"
              @visualizarItem="visualizarItem"
              @deletarItem="abrirDialogConfirmacao"
              @editarDisponibilidade="editarDisponibilidade"
              @carregar="carregar"
            />
          </v-layout>
          <v-flex
            align-self-center
            style="
              justify-content: end;
              align-items: center;
              display: flex;
            "
          >
            <v-tooltip bottom>
              <v-btn
                icon
                @click="pagination_conveniencia.page++"
                slot="activator"
                :disabled="pagination_conveniencia.totalItems <= pagination_conveniencia.page * visibleCards"
              >
                <v-icon size="40">arrow_forward_ios</v-icon>
              </v-btn>
              <span>Ir para Direita</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </v-tab-item>
      <v-tab-item>
        <v-layout row class="card-row">
          <v-flex
            align-self-center
            style="
              justify-content: start;
              align-items: center;
              display: flex;
            "
          >
            <v-tooltip bottom>
              <v-btn
                icon
                @click="pagination.page--"
                slot="activator"
                :disabled="pagination.page == 1"
              >
                <v-icon size="40">arrow_back_ios</v-icon>
              </v-btn>
              <span>Ir para esquerda</span>
            </v-tooltip>
          </v-flex>
          <v-layout
            column
            v-for="(objeto, index) in itens"
            :key="index"
          >
            <item
              :item="objeto"
              @editarItem="editarItem"
              @visualizarItem="visualizarItem"
              @deletarItem="abrirDialogConfirmacao"
              @editarDisponibilidade="editarDisponibilidade"
              @carregar="carregar"
            />
          </v-layout>
          <v-flex
            align-self-center
            style="
              justify-content: end;
              align-items: center;
              display: flex;
            "
          >
            <v-tooltip bottom>
              <v-btn
                icon
                @click="pagination.page++"
                slot="activator"
                :disabled="pagination.totalItems <= pagination.page * visibleCards"
              >
                <v-icon size="40">arrow_forward_ios</v-icon>
              </v-btn>
              <span>Ir para Direita</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </v-tab-item>
    </v-tabs-items>
    <v-dialog v-model="dialogPin" persistent max-width="400">
      <pin v-if="dialogPin" @autenticado="autenticado=true" :frentistaSelecionado="frentistaSelecionado" @fechar="dialogPin = false"/>
    </v-dialog>
    <v-dialog v-if="dialogCadItem && autenticado" v-model="dialogCadItem"  width="65em" :fullscreen="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm">
      <cad-item
        @fechar="dialogCadItem = false, itemSelecionado = undefined, autenticado=false"
        @carregar="carregar"
        :itemSelecionado="itemSelecionado"
      />
    </v-dialog>
    <v-dialog v-if="dialogDetalhesItem && autenticado" v-model="dialogDetalhesItem"  width="65em" :fullscreen="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm">
      <detalhes-item
        :item="itemSelecionado"
        @fechar="
          dialogDetalhesItem = false,
          itemSelecionado = undefined,
          autenticado=false
        "
      />
    </v-dialog>
    <v-dialog
      v-if="dialogConfirmacaoExclusao && autenticado"
      v-model="dialogConfirmacaoExclusao"
      width="55em"
    >
      <confirmacao-exclusao
        @confirmado="deletarItem"
        @fechar="dialogConfirmacaoExclusao = false, itemSelecionado = undefined, autenticado=false"
      >
        <template v-slot:principal>
          <h2
            v-if="itemSelecionado"
            class="error--text text-xs-center mb-2"
          >
            Tem certeza que você deseja excluir {{ itemSelecionado.nome }}?
          </h2>
        </template>
      </confirmacao-exclusao>
    </v-dialog>
    <v-dialog
      v-if="dialogDisponibilidadeItem && autenticado"
      v-model="dialogDisponibilidadeItem"
      width="45em"
    >
      <item-disponibilidade
        :item="itemSelecionado"
        @fechar="
          dialogDisponibilidadeItem = false,
          itemSelecionado = undefined,
          autenticado=false
        "
        @carregar="carregar"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import Item from '@/components/CardItem'
import CadItem from '@/components/dialogs/CadItem'
import DetalhesItem from '@/components/dialogs/DetalhesItem'
import ItemDisponibilidade from '@/components/dialogs/ItemDisponibilidade.vue'
import ConfirmacaoExclusao from '@/components/dialogs/ConfirmacaoExclusao.vue'
import Pin from '@/components/dialogs/DialogPin'
import { VMoney } from 'v-money'

export default {
  directives: { money: VMoney },
  components: {
    Item,
    CadItem,
    DetalhesItem,
    ItemDisponibilidade,
    ConfirmacaoExclusao,
    Pin
  },
  data () {
    return {
      lagura_tela: 0,
      currentIndex: 0,
      visibleCards: 1,
      mostrar: false,
      dialogCadItem: false,
      dialogDetalhesItem: false,
      dialogDisponibilidadeItem: false,
      dialogConfirmacaoExclusao: false,
      itens: [],
      itens_conveniencia: [],
      itens_combustiveis: [],
      autenticado: false,
      dialogPin: false,
      pagination: {
        page: 1,
        totalItems: 0
      },
      pagination_conveniencia: {
        page: 1,
        totalItems: 0
      },
      tabs: 0,
      itemSelecionado: undefined
    }
  },
  watch: {
    ready (val) {
      if (val) {
        this.carregar()
      }
    },
    tela (val) {
      this.ajustarTela(val)
      this.pagination.page = 1
      this.pagination_conveniencia.page = 1
      this.carregar()
    },
    tabs (val) {
      if (this.ready) this.carregar()
    },
    pagination: {
      handler (val) {
        if ((this.posto && this.tabs === 2) || (this.empresa && this.tabs === 1)) this.pegarItens()
      },
      deep: true
    },
    pagination_conveniencia: {
      handler (val) {
        if ((this.posto && this.tabs === 1) || (this.empresa && this.tabs === 0)) this.pegarItensConveniencia()
      },
      deep: true
    },
    frentista (val) {
      if (val && ((this.posto && this.tabs === 1) || (this.empresa && this.tabs === 0))) {
        this.pegarItens()
      }
    }
  },
  beforeMount () {
    if (this.posto) this.$store.dispatch('carregarCombustiveis')
    this.ajustarTela(this.$vuetify.breakpoint)
    if (this.ready) {
      this.carregar()
    }
  },
  computed: {
    tela () {
      return this.$vuetify.breakpoint
    },
    posto () {
      return this.$store.getters.posto
    },
    empresa () {
      return this.$store.getters.empresa
    },
    ready () {
      return !!this.empresa || !!this.posto
    },
    loading () {
      return this.$store.getters.loading
    },
    pages () {
      if (this.visibleCards == null ||
        this.pagination.totalItems == null
      ) return 0

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    },
    pageConvenienvia () {
      if (this.visibleCards == null ||
        this.pagination_conveniencia.totalItems == null
      ) return 0

      return Math.ceil(this.pagination_conveniencia.totalItems / this.pagination_conveniencia.rowsPerPage)
    },
    frentistaSelecionado () {
      return this.$store.getters.frentistaSelecionado
    },
    frentista () {
      return this.$store.getters.frentista
    }
  },
  methods: {
    carregar () {
      if (this.posto && this.tabs === 0) this.pegarItensCombustiveis()
      else if ((this.posto && this.tabs === 1) || (this.empresa && this.tabs === 0)) this.pegarItensConveniencia()
      else if ((this.posto && this.tabs === 2) || (this.empresa && this.tabs === 1)) this.pegarItens()
    },
    editarItem (item) {
      this.itemSelecionado = item
      this.dialogCadItem = true
      this.dialogPin = true
    },
    visualizarItem (item) {
      this.itemSelecionado = item
      this.dialogDetalhesItem = true
    },
    editarDisponibilidade (item) {
      this.itemSelecionado = item
      this.dialogDisponibilidadeItem = true
      this.dialogPin = true
    },
    abrirDialogConfirmacao (item) {
      this.itemSelecionado = item
      this.dialogConfirmacaoExclusao = true
    },
    deletarItem () {
      const data = {
        method: 'DELETE',
        id: this.itemSelecionado.id
      }
      this.$store.dispatch('itens', data).then(() => {
        this.dialogConfirmacaoExclusao = false
        this.pagination.page = 1
        this.pagination_conveniencia.page = 1
        this.itemSelecionado = undefined
        this.carregar()
        this.$store.dispatch('setSuccess', 'Item deletado com sucesso.')
      })
    },
    ajustarTela (val) {
      if (val) {
        if (val.xs) this.visibleCards = 1
        else if (val.sm) this.visibleCards = 1
        else if (val.md) this.visibleCards = 2
        else if (val.lg) this.visibleCards = 2
        else if (val.xl) this.visibleCards = 3
      }
    },
    pegarItens () {
      const data = {
        method: 'GET',
        parameters: {
          page: this.pagination.page,
          page_size: this.visibleCards,
          is_conveniencia: false,
          combustivel__isnull: true
        }
      }
      this.$store.dispatch('itens', data).then(json => {
        this.itens = json.results
        this.pagination.totalItems = json.count
      })
    },
    pegarItensConveniencia () {
      const data = {
        method: 'GET',
        parameters: {
          page: this.pagination_conveniencia.page,
          page_size: this.visibleCards,
          is_conveniencia: true,
          combustivel__isnull: true
        }
      }
      this.$store.dispatch('itens', data).then(json => {
        this.itens_conveniencia = json.results
        this.pagination_conveniencia.totalItems = json.count
      })
    },
    pegarItensCombustiveis () {
      const data = {
        method: 'GET',
        parameters: {
          categoria__referencia__iexact: 'combustivel',
          combustivel__isnull: false
        }
      }
      this.$store.dispatch('itens', data).then(json => {
        this.itens_combustiveis = json
      })
    }
  }
}
</script>

<style>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .5;
  position: absolute;
  width: 100%;
}

</style>
